import axios from "axios";
import { HOST_URL } from "./Host";
import { getUserCompanies, setUserCompanies } from "./CompanyActions";

export const SET_AUTHED_USER = "SET_AUTHED_USER";
export const UPDATE_AUTHED_USER = "UPDATE_AUTHED_USER";
export const REMOVE_AUTHED_USER = "REMOVE_AUTHED_USER";
export const RESET_STORE = "RESET_STORE";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Accept-Version": "2.0",
};

function setAuthedUser(user) {
  return {
    type: SET_AUTHED_USER,
    payload: user,
  };
}
export function updateAuthedUser(user) {
  return {
    type: UPDATE_AUTHED_USER,
    payload: user,
  };
}

export function removeAuthedUser() {
  return {
    type: REMOVE_AUTHED_USER,
  };
}

export const resetStore = () => {
  return {
    type: "RESET_STORE",
  };
};

export function login(credentials, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${HOST_URL}/auth/login`, credentials, {
        headers: {
          ...headers,
        },
      });

      // Succès de l'authentification
      let user = {
        token: response.data.data.accessToken,
        refreshToken: response.data.data.refreshToken,
        accessTokenExpiry: Math.floor(
          new Date(response.data.accessTokenExpiry).getTime() / 1000
        ), // Timestamp en sec
        refreshTokenExpiry: Math.floor(
          new Date(response.data.refreshTokenExpiry).getTime() / 1000
        ), // Timestamp en sec
      };
      const userData = await axios.get(`${HOST_URL}/auth/current`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${user.token}`,
        },
      });
      user = {
        ...user,
        ...userData.data.data,
      };

      await dispatch(setAuthedUser(user));
      await dispatch(getUserCompanies(user.token));
      callback({
        success: true,
        message: response.data.message,
        user: user,
      });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function EmailLessLogin(credentials, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${HOST_URL}/auth/login`, credentials, {
        headers: {
          ...headers,
        },
      });

      // Succès de l'authentification
      let user = {
        token: response.data.data.accessToken,
        refreshToken: response.data.data.refreshToken,
        accessTokenExpiry: Math.floor(
          new Date(response.data.accessTokenExpiry).getTime() / 1000
        ), // Timestamp en sec
        refreshTokenExpiry: Math.floor(
          new Date(response.data.refreshTokenExpiry).getTime() / 1000
        ), // Timestamp en sec
      };
      const userData = await axios.get(`${HOST_URL}/auth/current`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${user.token}`,
        },
      });
      user = {
        ...user,
        ...userData.data.data,
      };
      await dispatch(setAuthedUser(user));
      const companiesData = await axios.get(`${HOST_URL}/companies?limit=50`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${user.token}`,
        },
      });
      await dispatch(
        setUserCompanies({
          data: companiesData.data.data,
          meta: companiesData.data.meta,
        })
      );
      await callback({
        success: true,
        message: response.data.message,
        user: user,
        companies: companiesData.data.data,
      });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function PhoneLessLogin(credentials, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/auth/phone-login`,
        credentials,
        {
          headers: {
            ...headers,
          },
        }
      );

      // Succès de l'authentification
      let user = {
        token: response.data.data.accessToken,
        refreshToken: response.data.data.refreshToken,
        accessTokenExpiry: Math.floor(
          new Date(response.data.accessTokenExpiry).getTime() / 1000
        ), // Timestamp en sec
        refreshTokenExpiry: Math.floor(
          new Date(response.data.refreshTokenExpiry).getTime() / 1000
        ), // Timestamp en sec
      };
      const userData = await axios.get(`${HOST_URL}/auth/current`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${user.token}`,
        },
      });
      user = {
        ...user,
        ...userData.data.data,
      };
      await dispatch(setAuthedUser(user));
      const companiesData = await axios.get(`${HOST_URL}/companies`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${user.token}`,
        },
      });

      setUserCompanies({
        data: companiesData.data.data,
        meta: companiesData.data.meta,
      });
      await callback({
        success: true,
        message: response.data.message,
        user: user,
        companies: companiesData.data.data,
      });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function register(userData, callback) {
  return async () => {
    try {
      const response = await axios.post(`${HOST_URL}/accounts`, userData);

      callback({
        success: true,
        message: response.data.message,
        conflict: false,
      });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";
      let conflict = false;

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      if (error?.response?.status === 409) {
        conflict = true; // Mettre conflict à true si le code est 409
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
        conflict,
      });
    }
  };
}

export function verifyEmailLogin(credentials, callback) {
  return async () => {
    try {
      const response = await axios.post(`${HOST_URL}/auth/login`, credentials);

      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function verifyEmailLessLogin(credentials, callback) {
  return async () => {
    try {
      const response = await axios.post(`${HOST_URL}/auth/login`, credentials);

      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

// Code of a new account, sent by e-mail and by SMS at once
export function sendSignupOtp(credentials, callback) {
  return async () => {
    try {
      const response = await axios.post(
        `${HOST_URL}/auth/signup-login`,
        credentials,
      );

      callback({ success: true, message: response.data.message });
    } catch (error) {
      callback({
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Une erreur inattendue est survenue.",
      });
    }
  };
}

export function verifyPhoneLessLogin(credentials, callback) {
  return async () => {
    try {
      const response = await axios.post(
        `${HOST_URL}/auth/phone-login`,
        credentials
      );

      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function resendOTP(email, callback) {
  return async () => {
    try {
      const response = await axios.post(`${HOST_URL}/auth/resend-otp`, email);

      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function forgotPassword(email, callback) {
  return async () => {
    try {
      const response = await axios.post(
        `${HOST_URL}/auth/forgot-password`,
        email
      );

      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function resetPassword(credentials, callback) {
  return async () => {
    try {
      const response = await axios.post(
        `${HOST_URL}/auth/reset-password`,
        credentials
      );

      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function updateAccount(token, account, updateData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.put(
        `${HOST_URL}/accounts/${account}`,
        updateData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(updateAuthedUser(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}
export function deleteAccount(token, account, callback) {
  return async () => {
    try {
      const response = await axios.delete(`${HOST_URL}/accounts/${account}`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}
